import React, { Component } from "react";
import {
  Nav,
  TabsCustom,
  TabsCustomHeader,
  TabsCustomMenu,
  TabsCustomBody,
  TabsCustomItem,
  Loader,
  Card,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  BarChart,
} from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import ShowOptionsNGRA from "../../../components/general/ShowOptionsNGRA-v2";

import axiosConfig from "../../../utils/axiosConfig";
import {
  getCurrencyValue,
  getPercentageValue,
  getValue,
} from "../../../utils/general";

import AuthContext from "../../../context/AuthContext";
import filterStore from "../../../stores/filterStore";
import { colors } from "../../../utils/colors";

const CHART_COLORS = [
  colors.blue[0],
  colors.green[0],
  colors.orange[0],
  colors.purple[0],
  colors.red[0],
  colors.cyan[0],
  colors.yellow[0],
  colors.pink[0],
];

const getRegionColor = (index) => {
  return CHART_COLORS[index % CHART_COLORS.length];
};

const TOTAL_COLOR = "#1e1f26";

export default class CompanyReporting extends Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("companyReporting");
    this.state = saved || {
      isLoad: false,
      year: 0,
      network: 0,
      group: 0,
      region: 0,
      agency: 0,
      dateStart: null,
      dateEnd: null,
      companyMultiples: [],
      tabsIndexType: 0,
      reportingData: null,
    };
  }

  static contextType = AuthContext;

  componentWillUnmount() {
    filterStore.getState().setPageState("companyReporting", this.state);
  }

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("companyReporting", data);
    this.setState(
      {
        year: data.year,
        network: data.network,
        group: data.group,
        region: data.region,
        agency: data.agency,
        dateStart: data.dateStart,
        dateEnd: data.dateEnd,
        companyMultiples: data.companyMultiples,
      },
      () => {
        this.getData();
      },
    );
  };

  getData = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("/company-reporting/get-data", {
        data: {
          dateStart: this.state.dateStart,
          dateEnd: this.state.dateEnd,
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
          companyMultiples: this.state.companyMultiples,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              reportingData: res.data.data,
              isLoad: false,
            });
          } else {
            this.setState({ isLoad: false, reportingData: null }, () => {
              alert("Une erreur est survenue");
            });
          }
        })
        .catch(() => {
          this.setState({ isLoad: false }, () => {
            alert("Une erreur est survenue");
          });
        });
    });
  };

  getTypeKey = () => {
    const types = ["RC", "PJ", "PM"];
    return types[this.state.tabsIndexType] || "RC";
  };

  downloadRegionCSV = (regionName, folders) => {
    if (!folders || !folders.length) return;
    const headers = [
      "ID",
      "Référence",
      "Région",
      "Compagnie",
      "Expert",
      "Agence locale",
      "Date mission",
      "Date clôture",
      "Date soumission",
      "Délai mission-soumission",
      "Délai mission-dépôt",
      "Honoraires",
      "Nature événement",
      "Nature expertise",
      "Statut",
    ];
    const rows = folders.map((f) => [
      f.fg_id,
      f.fg_reference,
      f.region,
      f.company,
      f.expertName,
      f.localAgency,
      f.dateMission,
      f.dateClosing,
      f.dateSoumission,
      f.delaiMissionSoumission ?? "",
      f.delaiMissionDepot ?? "",
      f.honoraires,
      f.natureEvent,
      f.natureExpertise,
      f.statut,
    ]);
    const csv = [headers, ...rows]
      .map((r) => r.map((v) => `"${v}"`).join(";"))
      .join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `dossiers_${regionName}_${this.getTypeKey()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  renderReportingTable = (typeData) => {
    if (!typeData) return null;

    const allRows = [...typeData.regions, typeData.total];

    return (
      <Card title="Reporting" classNameChildren="overflow-x-auto">
        <Table>
          <Thead>
            <Tr>
              <Th>Région</Th>
              <Th>Missions reçues</Th>
              <Th>Rapports déposés</Th>
              <Th>Performance</Th>
              <Th>Dossiers en retard</Th>
              <Th>RDV prévus</Th>
              <Th>Délai mission-soumission</Th>
              <Th>Délai traitement</Th>
              <Th>Délai mission-dépôt</Th>
              <Th>CA HT</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {allRows.map((row, idx) => (
              <Tr key={idx}>
                <Td className={row.name === "TOTAL" ? "fw-bold" : ""}>
                  {row.name}
                </Td>
                <Td>{row.missionsRecues}</Td>
                <Td>{row.rapportsDeposes}</Td>
                <Td>{getPercentageValue(row.performance)}</Td>
                <Td>{row.dossiersRetard}</Td>
                <Td>{row.rdvPrevus}</Td>
                <Td>{getValue(row.delaiMissionSoumission)} j</Td>
                <Td>{getValue(row.delaiTraitementSolution)} j</Td>
                <Td>{getValue(row.delaiMissionDepot)} j</Td>
                <Td>{getCurrencyValue(row.ca)}</Td>
                <Td>
                  {typeData.foldersByRegion &&
                  typeData.foldersByRegion[row.name] ? (
                    <FontAwesomeIcon
                      icon={faDownload}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.downloadRegionCSV(
                          row.name,
                          typeData.foldersByRegion[row.name],
                        )
                      }
                    />
                  ) : null}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>
    );
  };

  renderPerformanceChart = (typeData) => {
    if (!typeData || !typeData.monthlyPerformance) return null;

    const { labels, datasets } = typeData.monthlyPerformance;

    const regionKeys = Object.keys(datasets);
    const chartDatasets = regionKeys.map((regionName, idx) => ({
      label: regionName,
      data: datasets[regionName],
      type: "line",
      color: regionName === "TOTAL" ? TOTAL_COLOR : getRegionColor(idx),
    }));

    return (
      <Card title="Évolution mensuelle de la performance (%)">
        <BarChart
          digits={2}
          height={300}
          isLegend={true}
          yAxes={[{ id: "A", ticks: { beginAtZero: true } }]}
          labels={labels}
          dataSet={chartDatasets}
        />
      </Card>
    );
  };

  renderDelayCharts = (typeData) => {
    if (!typeData) return null;
    const typeKey = this.getTypeKey();

    const regionRows = typeData.regions || [];
    const delayLabels = regionRows.map((r) => r.name);
    const yAxesZero = [{ id: "A", ticks: { beginAtZero: true } }];

    return (
      <Card
        title={`Délais moyens ${typeKey}`}
        classNameChildren="overflow-x-auto"
      >
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 50%", minWidth: 300, padding: 10 }}>
            <BarChart
              title={`Délai mission-soumission ${typeKey}`}
              digits={2}
              height={300}
              yAxes={yAxesZero}
              labels={delayLabels}
              dataSet={[
                {
                  label: "Jours",
                  data: regionRows.map((r) => r.delaiMissionSoumission),
                  color: colors.blue[0],
                },
              ]}
            />
          </div>
          <div style={{ flex: "1 1 50%", minWidth: 300, padding: 10 }}>
            <BarChart
              title={`Délai mission-dépôt ${typeKey}`}
              digits={2}
              height={300}
              yAxes={yAxesZero}
              labels={delayLabels}
              dataSet={[
                {
                  label: "Jours",
                  data: regionRows.map((r) => r.delaiMissionDepot),
                  color: colors.blue[0],
                },
              ]}
            />
          </div>
        </div>
        {typeData.monthlyDelays ? (
          <div style={{ padding: 10 }}>
            <BarChart
              title={`Délai mission-dépôt ${typeKey} par mois`}
              digits={2}
              height={300}
              yAxes={yAxesZero}
              labels={typeData.monthlyDelays.labels}
              dataSet={[
                {
                  label: "Jours",
                  data: typeData.monthlyDelays.delaiMissionDepot,
                  type: "line",
                  color: colors.blue[0],
                },
              ]}
            />
          </div>
        ) : null}
      </Card>
    );
  };

  renderCumulativePerformanceChart = (typeData) => {
    if (!typeData || !typeData.cumulativePerformance) return null;

    const { labels, datasets } = typeData.cumulativePerformance;

    const regionKeys = Object.keys(datasets);
    const chartDatasets = regionKeys.map((regionName, idx) => ({
      label: regionName,
      data: datasets[regionName],
      type: "line",
      color: regionName === "TOTAL" ? TOTAL_COLOR : getRegionColor(idx),
    }));

    return (
      <Card title={`Performance par région par mois (cumulée)`}>
        <BarChart
          digits={2}
          height={300}
          isLegend={true}
          yAxes={[{ id: "A", ticks: { beginAtZero: true } }]}
          labels={labels}
          dataSet={chartDatasets}
        />
      </Card>
    );
  };

  renderRetardCharts = (typeData) => {
    if (!typeData) return null;
    const typeKey = this.getTypeKey();

    return (
      <Card
        title={`Retards de traitement ${typeKey}`}
        classNameChildren="overflow-x-auto"
      >
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 50%", minWidth: 300, padding: 10 }}>
            {typeData.retardsByRegion ? (
              <BarChart
                title={`Retards ${typeKey} par région`}
                digits={0}
                height={300}
                yAxes={[{ id: "A", ticks: { beginAtZero: true } }]}
                labels={typeData.retardsByRegion.labels}
                dataSet={[
                  {
                    label: "Dossiers",
                    data: typeData.retardsByRegion.data,
                    color: colors.cyan[0],
                  },
                ]}
              />
            ) : null}
          </div>
          <div style={{ flex: "1 1 50%", minWidth: 300, padding: 10 }}>
            {typeData.retardsByMonth ? (
              <BarChart
                title={`Retards ${typeKey} par mois mission`}
                digits={0}
                height={300}
                yAxes={[{ id: "A", ticks: { beginAtZero: true } }]}
                labels={typeData.retardsByMonth.labels}
                dataSet={[
                  {
                    label: "Dossiers",
                    data: typeData.retardsByMonth.data,
                    color: colors.cyan[0],
                  },
                ]}
              />
            ) : null}
          </div>
        </div>
      </Card>
    );
  };

  render() {
    const typeKey = this.getTypeKey();
    const typeData = this.state.reportingData
      ? this.state.reportingData[typeKey]
      : null;

    return (
      <>
        <FadeIn>
          <Nav className="mb-10 mb-20-xl nowrap" title="RC/PJ/PM" />
          <ShowOptionsNGRA
            isChange={true}
            className="mb-10 mb-20-xl"
            onDataChange={this.handleDataChange}
            initialFilters={filterStore
              .getState()
              .getPageFilters("companyReporting")}
            isDateStart={true}
            isDateEnd={true}
            isAll={true}
            isCompanyMultiples={true}
            visibilityRole={this.props.visibilityRole}
            visibilityType={this.props.visibilityType}
            preloadRole={this.props.preloadRole}
            preloadType={this.props.preloadType}
            limitUserType={this.props.limitUserType}
            limitUserRole={this.props.limitUserRole}
            allUserRole={this.props.allUserRole}
          />
          <TabsCustom>
            <TabsCustomHeader>
              {["RC", "PJ", "PM"].map((tabName, idx) => (
                <TabsCustomMenu
                  key={idx}
                  title={tabName}
                  active={this.state.tabsIndexType === idx}
                  onClick={() => {
                    if (this.state.tabsIndexType !== idx) {
                      this.setState({ tabsIndexType: idx });
                    }
                  }}
                />
              ))}
            </TabsCustomHeader>
            <TabsCustomBody noCard>
              {["RC", "PJ", "PM"].map((_, idx) => (
                <TabsCustomItem
                  key={idx}
                  active={this.state.tabsIndexType === idx}
                >
                  {this.state.tabsIndexType === idx && typeData ? (
                    <>
                      {this.renderReportingTable(typeData)}
                      <div className="mt-10 mt-20-xl">
                        {this.renderDelayCharts(typeData)}
                      </div>
                      <div className="mt-10 mt-20-xl">
                        {this.renderPerformanceChart(typeData)}
                      </div>
                      <div className="mt-10 mt-20-xl">
                        {this.renderCumulativePerformanceChart(typeData)}
                      </div>
                      <div className="mt-10 mt-20-xl">
                        {this.renderRetardCharts(typeData)}
                      </div>
                    </>
                  ) : null}
                </TabsCustomItem>
              ))}
            </TabsCustomBody>
          </TabsCustom>
          <Loader show={this.state.isLoad} />
        </FadeIn>
      </>
    );
  }
}
